import Person3Icon from '@mui/icons-material/Person3';
import Person4Icon from '@mui/icons-material/Person4';
import {Box} from '@mui/material';
import {IGetCustomerInfoResponse} from '../../../models/customer.model';

interface IProfileCard extends IGetCustomerInfoResponse {
    setState: (state: 'profile' | 'support' | 'userProfile') => void;
}

const ProfileCard = ({
    fullName,
    mobileNumber,
    nationalCode,
    birthDatePersian,
    genderType,
    setState,
    goftinoUserId,
}: IProfileCard) => {
    return (
        <Box
            sx={{
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: '28px',
                background: 'rgba(255, 255, 255, 0.4)',
                backdropFilter: 'blur(12px)',
                WebkitBackdropFilter: 'blur(12px)',
                marginInline: '20px',
                padding: '20px',
                boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.16)',
            }}
        >
            {/* <MoreHorizIcon sx={{ color: "var(--tirnary-text-color)", marginTop: "-20px" }} onClick={() => setState('userProfile')} /> */}
            {/* <div className="flex items-center w-full">
                <div
                    className="shadow-md p-2 mx-auto mt-[-85px]"
                    style={{
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '28px',
                        background: 'rgba(255, 255, 255, 0.3)',
                        backdropFilter: 'blur(12px)',
                        WebkitBackdropFilter: 'blur(12px)',
                    }}
                >
                    {genderType === 'Female' ? (
                        <Person3Icon
                            sx={{fontSize: '70px', color: '#0158CC'}}
                        />
                    ) : (
                        <Person4Icon
                            sx={{fontSize: '70px', color: '#0158CC'}}
                        />
                    )}
                </div>
            </div> */}
            {fullName && (
                <div className="text-center my-6 font-bold text-[1.1rem] text-[var(--primary-text-color)]">
                    {fullName}
                </div>
            )}
            <div className="flex w-full justify-center text-[var(--primary-text-color)]">
                <div className="flex flex-col gap-2 w-full text-center">
                    <div className="text-[var(--tirnary-text-color)] text-[.8rem]">
                        شماره همراه
                    </div>
                    <div className="text-[.9rem]">{mobileNumber}</div>
                </div>
                <div
                    className={`flex flex-col gap-2 w-full ${birthDatePersian ? 'border-x border-x-[#D7DBEC]' : 'border-r border-r-[#D7DBEC]'}  text-center`}
                >
                    <div className="text-[var(--tirnary-text-color)] text-[.8rem]">
                        کد ملی
                    </div>
                    <div className="text-[.9rem]">{nationalCode}</div>
                </div>
                {birthDatePersian && (
                    <div className="flex flex-col gap-2 w-full text-center">
                        <div className="text-[var(--tirnary-text-color)] text-[.8rem]">
                            تاریخ تولد
                        </div>
                        <div className="text-[.9rem]">{birthDatePersian}</div>
                    </div>
                )}
            </div>
        </Box>
    );
};

export default ProfileCard;
